import React, { useState, useEffect, Fragment } from 'react';
import { LocalSettings } from './LocalSettings';
import ParticipantStack from '../containers/ParticipantStack';
import ChatArea from '../containers/ChatArea';
import FormOptionnal from './FormOptional';
import { VideoDeviceInfo, AudioDeviceInfo, DeviceManager } from '@azure/communication-calling';
import { Stack } from '@fluentui/react';
import { CloseIcon } from '@fluentui/react-icons-northstar';
import {
  fullHeightStyles,
  paneHeaderStyle,
  settingsContainerStyle,
  paneHeaderTextStyle
} from './styles/CommandPanel.styles';
import { Footer } from './Footer';

export interface CommandPanelAllProps {
  videoDeviceInfo: VideoDeviceInfo;
  videoDeviceList: VideoDeviceInfo[];
  audioDeviceList: AudioDeviceInfo[];
  audioDeviceInfo: AudioDeviceInfo;
  setVideoDeviceInfo(device: VideoDeviceInfo): void;
  setAudioDeviceInfo(device: AudioDeviceInfo): void;
  deviceManager: DeviceManager;
  selectedPanePeople: any;
  selectedPaneSettings: any;
  selectedPaneAdd: any;
  setSelectedPanePeople: any;
  setSelectedPaneSettings: any;
  setSelectedPaneAdd: any;
  darkColor: string;
}

export const CommandPanelAll = (props: CommandPanelAllProps): JSX.Element => {
  // console.log(props.darkColor, 'darkColor')
  return (
    <Stack styles={fullHeightStyles}>
      {props.selectedPaneSettings && (
        <Fragment>
          <Stack.Item className={paneHeaderStyle}>
            <div style={{ width: '100%', background: props.darkColor, height: '45px', borderBottom: '1px solid #ccc' }}>
              <div style={{ fontSize: '18px', margin: '8px 10px !important', }} className={paneHeaderTextStyle}>
                {'Settings'}
              </div>
              <div style={{ fontSize: '16px', float: 'right', cursor: 'pointer' }} className={paneHeaderTextStyle}>
                <CloseIcon onClick={() => { props.setSelectedPaneSettings(false) }} />
              </div>
            </div>
          </Stack.Item>
          <Stack.Item>
            <div className={settingsContainerStyle}>
              <LocalSettings
                videoDeviceList={props.videoDeviceList}
                audioDeviceList={props.audioDeviceList}
                audioDeviceInfo={props.audioDeviceInfo}
                videoDeviceInfo={props.videoDeviceInfo}
                setVideoDeviceInfo={props.setVideoDeviceInfo}
                setAudioDeviceInfo={props.setAudioDeviceInfo}
                deviceManager={props.deviceManager}
              />
            </div>
          </Stack.Item>
        </Fragment>
      )}
      {props.selectedPaneAdd && (
        <Fragment>
          <Stack.Item className={paneHeaderStyle}>
            <div style={{ width: '100%', background: props.darkColor, height: '45px', borderBottom: '1px solid #ccc', marginTop: '15px' }}>
              <div style={{ fontSize: '18px', margin: '8px 10px !important', }} className={paneHeaderTextStyle}>
                {'Additional Information'}
              </div>
              <div style={{ fontSize: '16px', float: 'right', cursor: 'pointer' }} className={paneHeaderTextStyle}>
                <CloseIcon onClick={() => { props.setSelectedPaneAdd(false) }} />
              </div>
            </div>
          </Stack.Item>
          <Stack.Item>
            <FormOptionnal darkColor={props.darkColor} />
          </Stack.Item>
        </Fragment>
      )}
      {props.selectedPanePeople && (
        <Fragment>
          <Stack.Item className={paneHeaderStyle}>
            <div style={{ width: '100%', background: props.darkColor, height: '45px', borderBottom: '1px solid #ccc', marginTop: '15px' }}>
              <div style={{ fontSize: '18px', margin: '8px 10px !important', }} className={paneHeaderTextStyle}>
                {'People'}
              </div>
              <div style={{ fontSize: '16px', float: 'right', cursor: 'pointer' }} className={paneHeaderTextStyle}>
                <CloseIcon onClick={() => { props.setSelectedPanePeople(false) }} />
              </div>
            </div>
          </Stack.Item>
          <Stack.Item>
            <ParticipantStack />
          </Stack.Item>
          <Stack.Item>
            <Footer />
          </Stack.Item>
        </Fragment>
      )}
    </Stack>
  );
};
